module.exports = [{"code":1,"name":"高危"},{"code":2,"name":"化工"},{"code":3,"name":"一般"}]


//////////////////
// WEBPACK FOOTER
// ./static/json/dictionary/coType.json
// module id = K7vU
// module chunks = 11